import React from 'react';

function Mandates() {

  return (
    <div className='Mandates'>
        <h1>The Individuals with Disabilities Education Act (2004) (Section 300.304) mandates the following:</h1>
        <li>Parent/family permission obtained prior to assessment.</li>
        <li>A standardized assessment must be used for initial, triannual, and exit assessments (unless the IEP team determines otherwise).</li>
        <li>Assessments must be administered in the student's primary language/preferred method of communication.</li>
        <li>Assessments must be administered by trained personnel using instructions provided by their producer.</li>
        <li>Multiple assessments must be used.</li>
    </div>
  );
}

export default Mandates;
